import type { KinerjaStatus } from 'types/kinerja'

export const skpStatusWaitingApproval: KinerjaStatus[] = [
  'WAITING_APPROVAL',
  'REVISED',
]

export const skpStatusPerencanaanFinal: KinerjaStatus[] = [
  'APPROVED',
  'READY',
  'WAITING_EVALUATION',
]

export const tabNames = [
  'Hasil Kerja Utama',
  'Hasil Kerja Tambahan',
  'Perilaku Kerja',
  'Pengajuan',
]

export const tabNamesSubmitted = [
  'Hasil Kerja Utama',
  'Hasil Kerja Tambahan',
  'Perilaku Kerja',
]

export const reviewTabNames = [
  'Hasil Kerja Utama',
  'Hasil Kerja Tambahan',
  'Perilaku Kerja',
  'Persetujuan',
]

export const tabNamesV2 = [
  'Praktik Pembelajaran',
  'Pengembangan Kompetensi',
  'Tugas Tambahan',
  'Perilaku Kerja',
  'Rangkuman',
]

export const tabNamesV3 = [
  'Pelaksanaan Tugas Pokok',
  'Praktik Kinerja',
  'Pengembangan Kompetensi',
  'Perilaku Kerja',
  'Rangkuman',
]

export const tabNamesV3Submitted = tabNamesV3.slice(0, 4)

export const reviewTabNamesV3 = tabNamesV3.slice(0, 4).concat(['Persetujuan'])

export const buktiKaryaCategoryMappings = [
  {
    key: 'ARTIKEL',
    iconName: 'newspaper',
    title: 'Artikel',
  },
  {
    key: 'MATERI_AJAR',
    iconName: 'text_snippet',
    title: 'Materi Ajar',
  },
  {
    key: 'BAHAN_AJAR',
    iconName: 'text_snippet',
    title: 'Bahan Ajar',
  },
  {
    key: 'DOKUMEN_TEKNIS',
    iconName: 'addchart',
    title: 'Dokumen Teknis',
  },
  {
    key: 'KEPEMIMPINAN_SEKOLAH',
    iconName: 'groups',
    title: 'Kepemimpinan Sekolah',
  },
  {
    key: 'PRAKTIK_PEMBELAJARAN',
    iconName: 'book',
    title: 'Praktik Pembelajaran',
  },
  {
    key: 'PRAKTIK_BAIK',
    iconName: 'playlist_add_check',
    title: 'Praktik Baik',
  },
  {
    key: 'RPP',
    iconName: 'list',
    title: 'RPP/Modul Ajar',
  },
  {
    key: 'KARYA_LAINNYA',
    iconName: 'web',
    title: 'Karya Lainnya',
  },
  {
    key: 'KARYA_LAINNYA',
    iconName: 'web',
    title: 'Lainnya',
  },
]

export const tugasPokok = [
  'Guru merencanakan pembelajaran atau pembimbingan dalam mendukung pembelajaran yang bermutu untuk semua',
  'Guru membimbing dan melatih peserta didik dalam mendukung pembelajaran yang bermutu untuk semua',
  'Guru melaksanakan pembelajaran atau pembimbingan dalam mendukung pembelajaran yang bermutu untuk semua',
  'Guru menilai hasil pembelajaran atau pembimbingan dalam mendukung pembelajaran yang bermutu untuk semua',
]

export const tugasPokokPamong = [
  'Terlaksananya identifikasi kebutuhan belajar dan perencanaan pembelajaran/pembimbingan/pelatihan dalam mewujudkan pembelajaran yang bermutu untuk semua pada satuan pendidikan nonformal',
  'Terlaksananya pembelajaran/pembimbingan/pelatihan dalam mewujudkan pembelajaran yang bermutu untuk semua pada satuan pendidikan nonformal',
  'Terlaksananya penilaian dan evaluasi  pembelajaran/pembimbingan/pelatihan dalam mewujudkan pembelajaran yang bermutu untuk semua pada satuan pendidikan nonformal',
]
